import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingIcon from "../images/Loading_icon.gif";
import SearchConsultantRow from "../components/SearchConsultants/SearchConsultantRow";
import "../styles/searchConsultants.css";
import JumpingDots from "../images/JumpingDots.gif";
import { UrlContext } from "../contexts/UrlContext";

export default function SearchConsultants() {
  useEffect(() => {
    document.title = "Search Consultants";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const q = useParams().q;
  const [searchExpand, setSearchExpand] = useState(false);
  const [locationExpand, setLocationExpand] = useState(false);
  const [data, setData] = useState(null);
  const [backupData, setBackupData] = useState(null);
  const [total, setTotal] = useState(null);
  const [filterName, setFilterName] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const nameInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const [projects, setProjects] = useState([]);
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const url = `${API_URL}search-consultants/${q}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setData(data.data);
        setBackupData(data.data);
        setTotal(data.total);
        setClientData(data.client_data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [q]);

  useEffect(() => {
    const url = `${API_URL}get-all-projects`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProjects(data.projects);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (filterName || filterLocation) {
      const filteredData = backupData.filter((item) => {
        const name = item?.name?.toLowerCase();
        const location = item?.location?.toLowerCase();
        return (
          name?.includes(filterName?.toLowerCase()) &&
          location?.includes(filterLocation?.toLowerCase())
        );
      });
      setData(filteredData);
    } else {
      setData(backupData);
    }
  }, [filterName, filterLocation, backupData]);

  return (
    <>
      <div className="container-div">
        <h1 className="search-con-totalHeading">
          {total>0 && (`${total} consultants are found`)}
          {loading && (<img src={JumpingDots} alt="" style={{ width: "36px" }} />)}
        </h1>
      </div>
      <div className="search-con-table container-div">
        <ul className="search-con-filters list-unstyled form-inline">
          <li className="search-con-name-filter">
            <span className="no-select">Search Name</span>
            <div className="search-con-search-box">
              <input
                className={
                  searchExpand
                    ? "search-con-search-input search-con-filter-expand"
                    : "search-con-search-input"
                }
                placeholder="Search Name"
                onChange={(e) => setFilterName(e.target.value)}
                value={filterName}
                ref={nameInputRef}
              />
              <i
                className="search-con-search-icon fa-solid fa-magnifying-glass"
                onClick={(e) => {
                  setSearchExpand(!searchExpand);
                  // nameInputRef.current.focus()
                }}
              />
            </div>
          </li>
          <li className="search-con-location-filter">
            <span className="no-select">Location</span>
            <div className="search-con-searchLoc-box">
              <input
                className={
                  locationExpand
                    ? "search-con-searchLoc-input search-con-location-expand"
                    : "search-con-searchLoc-input"
                }
                placeholder="Location"
                onChange={(e) => setFilterLocation(e.target.value)}
                value={filterLocation}
                ref={locationInputRef}
              />
              <i
                className="search-con-searchLoc-icon fa-solid fa-magnifying-glass"
                onClick={(e) => {
                  setLocationExpand(!locationExpand);
                  // locationInputRef.current.focus()
                }}
              />
            </div>
          </li>
        </ul>
        {data ? (
          <>
            {data?.map((consultant, index) => {
              return (
                <SearchConsultantRow
                  key={index}
                  consultant={consultant}
                  projects={projects}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />
              );
            })}
            {data.length === 0 && (
              <div className="search-con-table-row">
                <div className="search-con-row-top" style={{ height: "45px" }}>
                  <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                    No consultant found
                  </h5>
                </div>
                <div className="search-con-row-bottom"></div>
              </div>
            )}
          </>
        ) : (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <img
              src={LoadingIcon}
              alt="Loading..."
              style={{ height: "50px" }}
            />
            <h4 style={{ marginTop: "20px" }}>please wait</h4>
          </div>
        )}
      </div>
      <br />
      <br />
      <div className="client-div">
        <h5>Client</h5>
        {clientData?.length > 0 ? (
          <div className="list-group">
            {clientData.map((client) => (
              <a
                key={client.name}
                href={`/app/AccountDetails/${client.projectID}`}
                target="_blank"
                rel="noopener noreferrer"
                className="list-group-item list-group-item-action list-group-item-light"
              >
                {client.name}
              </a>
            ))}
          </div>
        ) : (
          <div className="search-con-table-row">
            <div className="search-con-row-top" style={{ height: "45px" }}>
              <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                No clients found
              </h5>
            </div>
            <div className="search-con-row-bottom"></div>
          </div>
        )}
      </div>
    </>
  );
}
